import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AutoComplete, Input, Drawer, Form, Select } from "antd";
import "./LocationFilter.css";
import FilterState from "./state.Filter";
import FilterIndustry from "./prev.Filter";
const PreviousIndustries = ({
  checkIndustryObject,
  setCheckIndustryObject,
  setCheck,
  check,
  setFilter,
  addQuery,
  checkIndustryId,
  setCheckIndustryId,
  searchLocationFilter,
  setCheckCountryId,
  checkCountryId,
  countryObj,
  setcountryObj,
  setPrevIndustryObj,
  prevIndustryObj,
  setEmptyIndustryInput,
  emptyIndustryInput,
  fromCandMkt
}) => {
	const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [valueCheck, setValueCheck] = useState(check.map((item) => item.name));
	const [valueCheckId, setValueCheckId] = useState(
		check.map((item) => item.id),
	);
	const [isSelectVisible, setIsSelectVisible] = useState(false);
  useEffect(() => {
		setValueCheck(check.map((item) => item.name));
		setValueCheckId(check.map((item) => item.id));
	}, [check]);
  const showDrawer = () => {
    setVisible(true);
		setIsSelectVisible(false);
  };

  const onClose = () => {
    setVisible(false);
		setIsSelectVisible(false);
  };

  const handleCountryChange = (flag) => {
    // console.log("called log**");
    if (flag) {
      if ( emptyIndustryInput === "") {
        setEmptyIndustryInput();
      }
    }
    if (!flag) {
      setEmptyIndustryInput("");
    }
    setVisible(flag);
  };

  const containerStyle = {
    position: "relative",
    height: "100vh !important",
    overflow: "hidden",
    // textAlign: 'center',
  };

  // useEffect(() => {
	// 	if (check.length === 0 && !visible) {
	// 		const params = {
	// 			body: searchLocationFilter,
	// 		};
	// 		// dispatch(fetchKeySearchSkills(params));
	// 	} else if (check.length > 0 && !visible) {
	// 		searchLocationFilter.obj["skill"] = valueCheckId;
	// 		const params = {
	// 			body: searchLocationFilter,
	// 		};
	// 		// dispatch(fetchKeySearchSkills(params));
	// 	}
	// }, [visible]);

  const handleDeselect = (deselectedValue) => {
		const updatedValues = check.filter(
			(value) => value.name !== deselectedValue,
		);
		setCheck(updatedValues);
		setValueCheck(updatedValues);

		const deselectedIndex = check.findIndex(
			(value) => value.name == deselectedValue,
		);
		setCheckIndustryId(
			checkIndustryId.filter((val, index) => index !== deselectedIndex),
		);
	};

  return (
    <div className="search-location-filter-mobile">
      <Drawer
        className="location-drawer"
        onClose={onClose}
        visible={visible}
        closable={true}
        placement={"top"}
        afterOpenChange={(e) => {
          handleCountryChange(e);
        }}
        contentWrapperStyle={containerStyle}
        title={"Select previous industry"}
      >
        <FilterIndustry
          setCheckIndustryObject={setCheckIndustryObject}
          checkIndustryObject={checkIndustryObject}
          setcountryObj={setcountryObj}
          setIndustryObj={setCheckIndustryObject}
          industryObj={checkIndustryObject}
          countryObj={countryObj}
          setcheck={setCheck}
          check={check}
          setFilter={setFilter}
          addQuery={addQuery}
          checkIndustryId={checkIndustryId}
          setCheckIndustryId={setCheckIndustryId}
          setCheckCountryId={setCheckCountryId}
          checkCountryId={checkCountryId}
          mobileFilter={true}
          setVisible={setVisible}
          emptyIndustryInput={emptyIndustryInput}
          setEmptyIndustryInput={setEmptyIndustryInput}
          searchLocationFilter={searchLocationFilter}
          fromCandMkt = {fromCandMkt ?? false}
        />
      </Drawer>

      <Form>
				<Form.Item>
					<Select
						value={valueCheck}
						placeholder="Search skills"
						className="input"
						mode="multiple"
						bordered={false}
						onDeselect={handleDeselect}
						onClick={showDrawer}
						showSearch
						listHeight={160}
						open={isSelectVisible}
					></Select>
				</Form.Item>
			</Form>

      {/* <Input
        className="input"
        value={valueCheck}
        onClick={showDrawer}
        type={"input"}
        placeholder="Search previous industry"
      /> */}
    </div>
  );
};
export default PreviousIndustries;
